<template>
  <sds-input-control :label="label">
    <span class="d-flex">
      <span :id="uniqueId" class="screen-reader-only">
        {{ label }}
      </span>
      <SdsDateField
        v-model="dtInicial"
        :max="dtFinal"
        :name="$t('label.DATA_INICIAL')"
        :aria-labelledby="uniqueId"
        :type="type"
        :label-less-than-minimum="
          $t('label.ERROR_DATA_FINAL_MENOR_QUE_INICIAL')
        "
        :label-greater-than-maximum="
          $t('label.ERROR_DATA_INICIAL_MAIOR_QUE_FINAL')
        "
        :placeholder="placeholderInicial"
        v-bind="$attrs"
        :data-testid="label + '-dt-inicial'"
      />
      <span class="mx-2 d-flex align-center">
        {{ $t('label.ATE') }}
      </span>
      <SdsDateField
        v-model="dtFinal"
        :min="dtInicial"
        :name="$t('label.DATA_FINAL')"
        :aria-labelledby="uniqueId"
        :type="type"
        :label-less-than-minimum="
          $t('label.ERROR_DATA_FINAL_MENOR_QUE_INICIAL')
        "
        :label-greater-than-maximum="
          $t('label.ERROR_DATA_INICIAL_MAIOR_QUE_FINAL')
        "
        :placeholder="placeholderFinal"
        v-bind="$attrs"
        :data-testid="label + '-dt-final'"
      />
    </span>
  </sds-input-control>
</template>

<script setup lang="ts">
import SdsDateField from '@/components/SdsDateField.vue';
import { createIdentifier } from '@/utils';
import { ref, watch } from 'vue';
import moment from 'moment';

enum ReturnTypes {
  String = 'string',
  Date = 'date',
}

const props = defineProps({
  label: {
    type: String,
    default: 'Data',
  },
  type: {
    type: String,
    // "day", "month" ou "year"
    default: 'day',
  },
  returnType: {
    type: String,
    default: 'string',
  },
  placeholderInicial: {
    type: String,
    default: undefined,
  },
  placeholderFinal: {
    type: String,
    default: undefined,
  },
});

const uniqueId = createIdentifier('sds-date-range');
const dtInicial = ref(null);
const dtFinal = ref(null);

const emit = defineEmits(['change:data-inicial', 'change:data-final']);

const getFormatFromType = () => {
  switch (props.type) {
    case 'month':
      return 'MM/YYYY';
    case 'year':
      return 'YYYY';
    default:
      return 'DD/MM/YYYY';
  }
};

watch(dtInicial, (newValue) => {
  const value =
    props.returnType === ReturnTypes.String
      ? newValue
      : moment(newValue, getFormatFromType()).toDate();

  emit('change:data-inicial', value);
});

watch(dtFinal, (newValue) => {
  const value =
    props.returnType === ReturnTypes.String
      ? newValue
      : moment(newValue, getFormatFromType()).toDate();

  emit('change:data-final', value);
});
</script>
